<template>
  <div v-if="$can('view', 'Yacht')">
    <!--    <input-->
    <!--      ref="fileInput"-->
    <!--      title=""-->
    <!--      type="file"-->
    <!--      multiple-->
    <!--      class="file-input"-->
    <!--      :accept="accept || '*'"-->
    <!--      @change="filesChanged"-->
    <!--    >-->

    <v-row
      no-gutters
      align="center"
      class="mb-2"
    >
      <v-col
        v-if="selected.length > 0"
        cols="auto"
        class="grey--text body-1"
      >
        Change category to:
      </v-col>
      <v-col
        v-if="selected.length > 0"
        cols="auto"
        class="px-3"
      >
        <v-select
          :items="categories"
          item-text="text"
          item-value="key"
          item-color="color"
          outlined
          style="width: 250px"
          placeholder="Select category"
          dense
          background-color="white"
          hide-details
          :loading="changingCategory"
          @input="changeSelected"
        />
      </v-col>
      <v-spacer v-if="selected.length > 0" />
      <v-col v-else>
        <v-btn-toggle
          v-model="currentCategory"
          background-color="transparent"
          class="mb-2"
          dense
          color="primary"
          borderless
        >
          <v-btn
            v-for="category in categories"
            :key="category.key"
            :color="category.color"
            class="text-none"
            :value="category.key"
            text
          >
            {{ category.text }}
          </v-btn>
        </v-btn-toggle>
      </v-col>
      <v-col cols="auto">
        <file-upload
          ref="upload"
          v-model="files"
          :post-action="uploadUrl"
          multiple
          :data="{ type: currentCategory, yacht_id: yacht.id }"
          :headers="{ 'Authorization': 'Bearer ' + $store.state.auth.token, 'Accept': 'application/json' }"
          @input-file="inputFile"
        >
          <v-btn
            color="primary"
          >
            <v-icon
              left
              small
            >
              add
            </v-icon>
            Upload Documents
          </v-btn>
        </file-upload>
      </v-col>
    </v-row>

    <v-card class="elevation-10 radius-10">
      <v-card-text class="pa-0">
        <v-simple-table>
          <thead class="v-data-table-header theme--light">
            <tr>
              <th style="width: 1px" />
              <th
                style="width: 50px"
              >
                ID
              </th>
              <th>
                Name
              </th>
              <th style="width: 1px">
                Category
              </th>
              <th style="width: 1px">
                Added By
              </th>
              <th style="width: 1px">
                Added
              </th>
              <th
                v-if="$can('view-owner-visibility', 'Document')"
                style="width: 1px"
                class="text-no-wrap"
              >
                Owner shared
              </th>
              <th style="width: 1px" />
            </tr>
          </thead>
          <tbody v-if="files.length > 0">
            <tr
              v-for="file in files"
              :key="file.id"
              class="grey lighten-4"
            >
              <td />
              <td>
                <v-progress-circular
                  v-if="file.active"
                  color="grey"
                  :size="26"
                  :width="2"
                  indeterminate
                />
              </td>
              <td colspan="5">
                {{ file.name }}
              </td>
            </tr>
          </tbody>
          <tbody v-if="filteredDocuments.length > 0">
            <template v-for="document in filteredDocuments">
              <document-row
                :key="document.id"
                :document="document"
                :categories="categories"
                :selected="selected.indexOf(document.id) !== -1"
                @open-document="openDocument"
                @toggle:selected="toggleSelect"
                @deleted="documentDeleted"
                @update:document="documentUpdated"
              />
            </template>
          </tbody>
          <tbody v-else>
            <tr>
              <td
                colspan="6"
                class="text-center grey--text"
              >
                There are no documents right now
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-card-text>
    </v-card>

    <!--<editor-fold desc="Yacht Model Documents">-->
    <v-card class="elevation-10 radius-10 mt-12">
      <v-card-title class="subtitle-1">
        {{ yacht.model.full_name }} Documentation
      </v-card-title>
      <v-divider />
      <v-card-text class="pa-0">
        <table class="v-table theme--light radius-10">
          <tbody v-if="yachtModelDocuments.length > 0">
            <template v-for="document in yachtModelDocuments">
              <tr :key="document.id">
                <td>
                  {{ document.original_file }}
                </td>
                <td>
                  <span v-if="document.tag">
                    {{ document.tag | capitalize }}
                  </span>
                </td>
                <td>
                  <v-btn
                    text
                    color="grey darken-1"
                    class="text-capitalize"
                    @click="openDocument(document.id)"
                  >
                    <v-icon
                      left
                      small
                    >
                      cloud_download
                    </v-icon>
                    Download
                  </v-btn>
                </td>
              </tr>
            </template>
          </tbody>
          <tbody v-else>
            <tr>
              <td
                colspan="6"
                class="text-center grey--text"
              >
                There are no documents right now
              </td>
            </tr>
          </tbody>
        </table>
      </v-card-text>
    </v-card>
    <!--</editor-fold>-->
  </div>
</template>

<script>
import File from '@/models/File'
import DocumentRow from '@/components/business/yachts/documents/DocumentRow'
import Document from '@/models/Document'
import VueUploadComponent from 'vue-upload-component'
import { cloneDeep } from 'lodash'

export default {
  name: 'Documents',
  components: {
    DocumentRow,
    FileUpload: VueUploadComponent
  },
  props: {
    // todo: only docs needed
    yacht: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      documents: [],
      files: [],
      categories: [],
      currentCategory: null,
      selected: [],
      changingCategory: false
    }
  },
  computed: {
    yachtModelDocuments() {
      return this.yacht.model.files.filter(f => f.category === File.CATEGORY_DOCUMENT)
    },
    filteredDocuments() {
      if (!this.currentCategory) return this.documents

      return this.documents.filter(d => {
        return d.type === this.currentCategory
      })
    }
  },
  created() {
    this.getCategories()

    this.documents = cloneDeep(this.yacht.documents)

    this.uploadUrl = process.env.VUE_APP_API_URL + '/documents/upload'
  },
  methods: {
    inputFile(newFile, oldFile) {
      if (newFile && !oldFile) {
        this.$refs.upload.update(newFile, { active: true })
        return
      }

      if (newFile && oldFile && !newFile.active && oldFile.active) {
        // Get response data

       this.$refs.upload.remove(newFile)
       this.documents.unshift(newFile.response)
      }
    },
    async getCategories() {
      this.categories = await Document.api.getCategories()
    },
    openDocument(fileId) {
      File.api.openDocument(fileId)
    },
    toggleSelect(id) {
      let index = this.selected.indexOf(id)

      if (index === -1) {
        this.selected.push(id)
        return
      }

      this.selected.splice(index, 1)
    },
    documentDeleted(id) {
      this.documents.splice(this.documents.findIndex(d => d.id === id), 1)
    },
    documentUpdated(document) {
      this.documents.splice(this.documents.findIndex(d => d.id === document.id), 1, document)
    },
    async changeSelected(changeTo) {
      this.changingCategory = true

      try {
        await Document.api.changeCategory(this.selected, changeTo)

        for (let document of this.documents) {
          if (this.selected.indexOf(document.id) === -1) continue

          document.type = changeTo

          this.documents.splice(this.documents.findIndex(d => d.id === document.id), 1, document)
        }

        this.$store.dispatch('alert', {
          text: 'Category changed',
          color: 'success'
        })

        this.selected = []
      } catch (e) {
        throw e
      } finally {
        this.changingCategory = false
      }
    }
  }
}
</script>

<style scoped>
.file-input {
  position: absolute;
  top: 100%;
  left: 100%;
  width: 100%;
  height: 100%;
  opacity: 0;
  z-index: 10;
  cursor: pointer;
}
</style>
